import type { PositionsList } from '@/queries/positions.query'
import type { Vault } from '@/types/vault'

interface PositionDataProps {
  balanceNative?: NonNullable<PositionsList>[number]['balanceNative']
  balanceUsd?: NonNullable<PositionsList>[number]['balanceUsd']
}

export type PositionedVaultsListElement = Vault & PositionDataProps
export type PositionedVault = Vault & PositionDataProps

type PositionedVaultsList = PositionedVaultsListElement[]

export function useVaultsWithPositions(vaults: Vault[], lpTokenBalances: PositionsList | null): PositionedVaultsList {
  return vaults.map((vault) => {
    const matchingBalance = lpTokenBalances?.find(
      (balance) => balance.vaultId === vault.vaultId && balance.network.name === vault.network.name
    )
    return {
      ...vault,
      balanceNative: matchingBalance?.balanceNative ?? undefined,
      balanceUsd: matchingBalance?.balanceUsd ?? undefined,
    }
  })
}
